<div class="suggested-questions-container">
    @for (question of questions; track question) {
        <div class="question" (click)="sendQuestionToInputBar(question)"><img class="chatbox-icon" src="svg/chats.svg">{{ question }}</div>
    }
</div>
